import { Button } from "@material-ui/core";
import tossball from "../../assets/images/rewards/tossball.png";
import maskgroup from "../../assets/images/rewards/BigMaskgroup.png";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../utils/auth";
import axios from "axios";

export default function Toss() {
  const navigate = useNavigate();
  const accessToken = getAuthToken();
  const [startPlay, setPlay] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [timeRemainingData, setTimeRemainingData] = useState(null);

  const timer = (date) => {
    const intervalId = setInterval(() => {
      if (date <= 0) {
        setTimeRemainingData(0)
        clearInterval(intervalId);
        // PlaYNowFunction()
      } else {
        date = date - 1000;
        const days = Math.floor(date / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((date % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((date % (1000 * 60)) / 1000);
        // let maindate = days;
        let mainhours = hours;
        let mainminte = minutes;
        let mainsecound = seconds;
        const countdownStr = `${mainhours}:${mainminte}:${mainsecound}`;
        // console.log(countdownStr)
        setTimeRemaining(countdownStr);
      }
    }, 1000);
  };

  const PlaYNowFunction = async () => {
    if (accessToken) {
      var PlayNow = {
        method: "GET",
        url: global.config.ROOTURL.prod + "/contest/coinToss/checkCanPlay",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      };
      axios(PlayNow)
        .then(({ data }) => {
          // console.log({ data });
          setPlay(data);
          setTimeRemainingData(data?.remainingTime)
          timer(data?.remainingTime);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      PlaYNowFunction();
      console.log("set-timeout-running");
    }, timeRemainingData);
  }, [timeRemainingData === 0,]);

  useEffect(() => {
    PlaYNowFunction();
    // unmounting the states
    return () => {
      setPlay(null);
    };
  }, []);

  return (
    <div className="coinTossContainer">
      <div className="TossContainer">
        <div className="coinTossImageContainer">
          <img alt="cointossImage" src={maskgroup} className="cointossImage" />
        </div>
        <div className="cointosscontent">
          <div>
            <p className="TossFontStyle">Toss Ka Boss</p>
            <div className="footerInnerdiv">
              <img alt="tossball" src={tossball} />
              <p className="tosssmallfont" style={{ paddingLeft: "10px" }}>
                Earn 2x Runs
              </p>
            </div>
          </div>

          {startPlay?.canPlay ? (
            <Button
              className="TossFontStyle TossButton"
              onClick={() => {
                navigate("/coin");
              }}
            >
              Play Now
            </Button>
          ) : (
            <Button
              className=" PrdictionButtondisable"
              disabled={true}
              style={{ fontSize: "17px" }}
            >
              {timeRemaining}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
